export const selectGroupReducer = (state, action) => {
  state.selectedGroup.value = action.payload;
  state.selectedGroup.members = {
    value: [],
    canLoadMore: false,
    offset: 0,
  };
  state.selectedGroup.memberSearch = {
    value: [],
    canLoadMore: false,
  };
};

export const selectUserReducer = (state, action) => {
  state.selectedUser = action.payload;
};

export const updateOrgNamesReducer = (state, action) => {
  const { id, name } = action.payload;

  // update groups
  state.brandGroups.value = state.brandGroups.value.map((group) =>
    group.parent === id ? { ...group, parent_name: name } : group
  );

  //update users table
  state.brandUsers.table.value = state.brandUsers.table.value.map((user) => ({
    ...user,
    organisations: user.organisations.map((org) => (org.id === id ? { ...org, name } : org)),
  }));
};

export const updateOrgDeleteReducer = (state, action) => {
  const { id } = action.payload;

  state.brandUsers.table.value = state.brandUsers.table.value.map((user) => ({
    ...user,
    organisations: user.organisations.filter((org) => org.id !== id),
  }));
};
